import type { MediaDeviceDescriptor } from '@shared/types';

export function findDeviceById(
  devices: MediaDeviceDescriptor[],
  id: string | null,
): MediaDeviceDescriptor | undefined {
  if (!id) return undefined;
  return devices.find((device) => device.id === id);
}

export function formatResolutionLabel(width: number, height: number): string {
  return `${width} \u00D7 ${height}`;
}
